<template>
  <div v-if="getPermission.opcockpito.view">
    <!-- <load-list-form ref="CreateForm" mode="create" :action="onRefresh"/> -->
    <load-list-form ref="CreateForm" mode="create"/>
    <outbound-remark-form ref="OutboundRemarkForm" mode="update" :onRefresh="updateRemark"/>

    <!-- <outbound-booking ref="OutboundBooking" mode="YY" :action="onfresh"/> -->
    <urgent-container-list ref="ViewUrgentContainerList" mode="view"/>

    <md-dialog :md-active.sync="isPictureModalShowing">
      <md-dialog-content>
        <h1>Photos</h1>
        <calling-api path="/api/w/ccic/photo/get">
        <div v-if="photos.length === 0">
          <h3>You don't have any photos taken by Drivers</h3>
        </div>
        <div v-else>
          <view-image  :key="p.photoUrl" :src="p.photoUrl" v-for="p in photos">
           <div v-if="!isLoading" class="space">
              <h3>Type: {{p.title}}</h3>
              <p>File Name: {{getPhotoName(p)}}</p>
            </div>
            <div v-if="isLoading" class="space">
              <p>File Name: {{getPhotoName(p)}}</p>
              <p>{{p.refTimeStamp}}</p>
            </div>            
          </view-image>
        </div>
          
        </calling-api>
      </md-dialog-content>
      <md-dialog-actions>
        <download-pictures-button :zip-file-name="photoZipFileName"
                                  :file-prefix-for-each-file="filePrefixForEachFile"
                                  :pics="photos.map(it=>it.photoUrl)"
                                  v-if="isLoading"/>
        <md-button class="md-primary" @click="isPictureModalShowing = false; isLoading = false;">Close</md-button>      </md-dialog-actions>
    </md-dialog>



     <md-dialog :md-active.sync="isFilterModalShowing">
      <md-dialog-content>
        <h1>Filter</h1>
        
        <div class = "inputBoxDouble" >

          <div class = "inputBoxSpace" >
            <md-field>
                <label>Chassis#</label>
                <md-input v-model="searchRequest.chassisNo"/>
            </md-field>
          </div>

          <div class = "inputBoxSpace" >
             <md-field>
                <label>LoadKey</label>
                <md-input v-model="searchRequest.seqNo"/>
            </md-field>
          </div>

        </div>

        <div class = "inputBoxDouble" >

          <div class = "inputBoxSpace" >
             <md-field>
                <label>Booking #</label>
                <md-input v-model="searchRequest.bookingNo"/>
            </md-field>
          </div>

          <div class = "inputBoxSpace" >
             <md-field>
                <label>IBD #</label>
                <md-input v-model="searchRequest.ibd"/>
            </md-field>
          </div>

        </div>

        <div class = "inputBoxDouble" >
          <div class = "inputBoxSpaceWide" >
          <auto-complete-master-data-select
                                                group="STC_CARRIER"
                                                label="Carrier"
                                                :init-value="searchRequest.carrier"
                                                :on-item-changed="handleCarrierChanged"
                                                >
          </auto-complete-master-data-select>
          </div>
        </div>

        <div class = "inputBoxDouble" >
          <div class = "inputBoxSpace" >
            <md-field>
              <label>Yard</label>
              <md-input v-model="searchRequest.transloadingYard" disabled/>
            </md-field>
          </div>

          <div class = "inputBoxSpace" >
            <md-field>
              <label>Seal#</label>
              <md-input v-model="searchRequest.sealNumber"/>
            </md-field>
          </div>
        </div>

        <div class = "inputBoxDouble" >
          <div class = "inputBoxSpace" >
             <datepicker v-model="searchRequest.sealUpdateDate.startDate">
                <label>Seal Update Date</label>
              </datepicker>
          </div>
          <div class = "inputBoxSpace" >
             <datepicker v-model="searchRequest.sealUpdateDate.endDate">
                <label>To</label>
              </datepicker>
          </div>
        </div>

      </md-dialog-content>
    </md-dialog>
    

    <WindowPortal v-model="weightTicketStatus"> 
      <button id="printf" onclick="window.print()">Print this page</button>
      <div style="height: 20px"></div>
      <h1 class = "heading1 centerPrint">{{weightTicketItem.company}}</h1>
      <div style="height: 10px"></div>
      <h1 class = "heading2 centerPrint">{{weightTicketItem.add1}}</h1>
      <h1 class = "heading2 centerPrint">{{weightTicketItem.add2}}</h1>
      <div style="height: 1px"></div>
      <h1 class = "heading2 centerPrint">Outbound</h1>
      <div style="height: 1px"></div>
      <div class ="hContainer" >
        <div class = "item0"></div>
        <div class = "item0">Rec.Window: {{weightTicketItem.receivingWindows}}
          WT.Ticket: {{weightTicketItem.scaleTicket}}/{{weightTicketItem.scanWt}}</div>
        <div class = "item0"><qrcode-vue :value="weightTicketItem.containerNo"/></div>
      </div>
      <div style="height: 10px"></div>
      <div class ="gcontainer">
        <div style="height: 10px"></div>
        <div class ="fContainer" >
          <div class = "item1">Load Key:</div>
          <div class = "item1">Chassis#:</div>
          <div class = "item1">Container#:</div>
          <div class = "item1">CTN Type:</div>
          <div class = "item1">Yard Loc:</div>
        </div>
        <div class ="fContainer">
          <div class = "item2">{{weightTicketItem.seqNo}}</div>
          <div class = "item2">{{weightTicketItem.chassisNo}}</div>
          <div class = "item2">{{weightTicketItem.containerNo}}</div>
          <div class = "item2"><master-data-display group="CCR_CNTRTYPE" :tag-id="weightTicketItem.ctnrType"/></div>
          <div class = "item2">{{weightTicketItem.locationNumber}}</div>
        </div>
        <div style="height: 10px"></div>
        <div class ="fContainer" >
          <div class = "item3">Grade</div>
          <div class = "item3">Bale Count:</div>
          <div class = "item3">Seal#:</div>
          <div class = "item3">Booking#:</div>
          <div class = "item3">SCAC:</div>
        </div>
        <div class ="fContainer">
          <div class = "item4">{{weightTicketItem.grade}}</div>
          <div class = "item4">{{weightTicketItem.bales}}</div>
          <div class = "item4">{{weightTicketItem.newSeal}}</div>
          <div class = "item4">{{weightTicketItem.bookingNo}}</div>
          <div class = "item4">{{weightTicketItem.carrier2}}</div>
        </div>
        <div style="height: 10px"></div>
        <div class ="fContainer">
          <div class = "item5">Scale Date(T):</div>
          <div class = "item5">Yard Goat(T)</div>
          <div class = "item5">YG Weight(T)</div>
          <div class = "item5">Tare Weight:</div>    
        </div>
        <div class ="fContainer">
          <div class = "item6">{{weightTicketItem.twDate | date}} {{weightTicketItem.twDate | time}}</div>
          <div class = "item6">{{weightTicketItem.twYgNo}}</div>
          <div class = "item6">{{weightTicketItem.twYgWeight + ' lb'}}</div>
          <div class = "item6">{{parseInt(weightTicketItem.tareWeight) + ' lb'}}</div>
        </div>
        <div style="height: 10px"></div>
        <div class ="fContainer"> 
          <div class = "item7">Scale Date(G):</div>
          <div class = "item7">Yard Goat(G):</div>
          <div class = "item7">YG Weight(G):</div>
          <div class = "item7">Gross Weight:</div>
        </div>
        <div class ="fContainer">
          <div class = "item8">{{weightTicketItem.gwDate | date}} {{weightTicketItem.gwDate | time}}</div>
          <div class = "item8">{{weightTicketItem.gwYgNo}}</div>
          <div class = "item8">{{weightTicketItem.gwYgWeight + ' lb'}}</div>
          <div class = "item8">{{parseInt(weightTicketItem.vgmWeight) + ' lb'}}</div>
        </div>
        <div style="height: 20px"></div>
        <div class ="fContainer">
          <div class = "item9"></div>
          <div class = "item9"></div>
          <div class = "item9">Net Weight:</div>
          <div class = "item9">{{parseInt(weightTicketItem.weight) + ' lb'}}</div>
        </div>
      </div>

      <dir hight= 10px></dir>
      <dir hight= 10px></dir>

      <table id= "signature">    
          <tr>
            <td>DRIVER NAME</td>
          </tr>
          <tr>
            <th>(PLEASE PRINT) : _______________________ </th>
            <td>GROSS BY: ________________________DEPUTY___________________________</td>
          </tr>
          <tr>
            <td>DRIVER</td>
          </tr>
          <tr>
            <th>SIGNATURE: ___________________________ </th>
            <td>TARE BY : _________________________DEPUTY___________________________</td>
         </tr>
      </table>
      
      <dir hight= 50px></dir>
        <h1 class = "wheading2 wcenterPrint">{{weightTicketItem.weightmaster4}}</h1>
        <h1 class = "wheading2 wcenterPrint">{{weightTicketItem.weightmaster5}}</h1>
        <h1 class = "wheading3 wcenterPrint">{{weightTicketItem.weightmaster1}}</h1>
        <h1 class = "wheading2">{{weightTicketItem.weightmaster2}}</h1>
        <h1 class = "wheading2">{{weightTicketItem.weightmaster3}}</h1>
        <dir hight= 50px></dir>

    </WindowPortal>

 
      <b-sidebar 
      type="is-light"
      :fullheight= true
      :fullwidth= false
      :overlay= false
      :right= true
      v-model="sideBar"
    >
    </b-sidebar>

    <outbound-form ref="ScaleGrossWeight" 
      mode="SWR"
      :action="onfresh"/>

    <outbound-form ref="ScaleTareWeight" 
      mode="STR"
      :action="onfresh"/>

    <outbound-upload-form ref="OutboundUploadForm" 
      mode="UPL" />

    <!-- <driver-SMS-form ref="DriverSMSForm"
      mode = "SMSOUTBOUND" />   -->

    <!-- <driver-SMS-form ref="DriverSMSLogForm"
      mode = "LOGOUTBOUND" /> -->
      
    <!-- <test ref="STCDriverSMSForm"
      mode = "STCSMSOUTBOUND"
      :onSend="updateSend" />   -->

    <md-dialog class="modalC" :md-active.sync="isWarning">
      <md-dialog-content class="icons-center">
        <i class="material-icons md-48 md-light">warning</i>
        <h1 class="modalTitle">{{ this.modalMessage }}</h1>
      </md-dialog-content>
    </md-dialog>

    <md-card  class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">

          <div v-if="active" class="md-layout-item md-size-15 md-small-size-100">
            <div class = "inputBoxOutbound" >
              <auto-complete-master-data-select
                                                group="REC_WINDOW"
                                                label="Rev. Windows"
                                                :preparedOptions="loaded_recwin"
                                                :init-value="searchRequest.receivingWindows"
                                                :on-item-changed="handleWindowsChanged"
                                                >
                </auto-complete-master-data-select>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-15 md-small-size-100">
            <div class = "inputBoxOutbound" >
              <md-field>
                  <label>Container#</label>
                  <md-input v-model="searchRequest.containerNo"/>
              </md-field>
            </div>
          </div>
          
          <!-- <div v-if="active" class="md-layout-item md-size-15 md-small-size-100">       
            <div class = "inputBoxOutbound" >
             <md-field>
                <label>Weight Ticket</label>
                <md-input v-model="searchRequest.scaleTicket"/>
            </md-field>
            </div>
          </div> -->

          <div v-if="active" class="md-layout-item md-size-15 md-small-size-100">
            <!-- 3rd col -->
            <div class = "inputBoxOutbound" >
             <md-field>
                <label>Input WTicket</label>
                <md-input v-model="searchRequest.scanWt"/>
            </md-field>
            </div>      
          </div>

          <div v-if="active" class="md-layout-item md-size-15 md-small-size-100">
            <!-- 4th col -->
            <div class = "inputBoxOutbound" >
             <datepicker v-model="searchRequest.gwDate.startDate">
                <label>GW Scale Date</label>
              </datepicker>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-15 md-small-size-100">
            <!-- 4th col -->
            <div class = "inputBoxOutbound" >
             <datepicker v-model="searchRequest.gwDate.endDate">
                <label>To</label>
              </datepicker>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-15 md-small-size-100">
          <!-- <div class = "filterBar" @click="genrerateAppt">filter</div> -->
             <md-button
                  class="custButtonFilter md-raised"
                  @click="filterBar"
                  > 
                 Filter
                  <!-- <div class = "upperLine">Generate</div>
                  <div class = "lowerLine">Appointment</div>  -->
                  </md-button
                >
          </div>

          <div v-if="getPermission.opcockpito.edit" class="md-layout-item md-size-100 md-small-size-100">
            <callingApiCenter
              :paths="[
                '/api/w/fsi/WebSearchOutbound',
                '/api/w/fsi/WebSaveOutbound',
                // '/api/w/fsi/WebGenerateInbound',
                // '/api/w/fsi/WebSaveOutbound',
                // '/api/w/gst/upload/loadlistpartial',
              ]"
            >
              <!-- <callingApiCenter
                path="/api/w/fsi/WebSaveInbound"
                :not-display-error="true"
              > -->

              <b-notification class = "notifySize"
                  type="is-success"
                  v-model="notifyActive"
                  aria-close-label="Close notification">
                  {{notifyMessage}}
                </b-notification>

                <!-- <md-button class="custButtonOutbound md-raised" @click="toggleCreate" :disabled="this.getPermission.fsireadonly.view || this.getPermission.ccicqc.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.view">New</md-button> -->
                <md-button v-if="getPermission.acnit.view" class="custButtonOutbound md-raised" 
                  @click="toggleCreate">New</md-button>
                
                <div v-if="allowFullSearch">
                   
                </div>  
                
                <md-button
                  
                  class="custButtonOutbound md-raised"
                  @click="getScaleWeight('TW')"
                  :disabled="notRemarkException || (!getTWScaledCond || this.getPermission.fsireadonly.view || this.getPermission.ccicqc.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcoptfsireadonly.view)"
                  > 
                  Scale Tare
                  </md-button
                >

                <md-button
                  
                  class="custButtonOutbound md-raised"
                  @click="getBaleUpload()"
                  :disabled="notRemarkException || (!getUploadCond || this.getPermission.fsireadonly.view || this.getPermission.ccicqc.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcoptfsireadonly.view)"
                  > 
                  Ticket Info
                  </md-button
                >

                <md-button
                  
                  class="custButtonOutbound md-raised"
                  @click="getScaleWeight('GW')"
                  :disabled="notRemarkException || (!getGWScaledCond || this.getPermission.fsireadonly.view || this.getPermission.ccicqc.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcoptfsireadonly.view)"
                  > 
                  Scale Gross
                  </md-button
                >

                <md-button
                  
                  class="custButtonOutbound md-raised"
                  @click="weightTicket()"
                  :disabled="notRemarkException || (!getWticketCond || this.getPermission.fsireadonly.view || this.getPermission.ccicqc.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcoptfsireadonly.view)"
                  > 
                  Print WTicket
                  </md-button
                >

                <md-button
                  
                  class="custButtonOutbound md-raised"
                  @click="outboundRemark"
                  :disabled="!getRemarkCond"
                  > 
                  Remark
                  </md-button
                >

                <!-- <md-button
                  class="custButtonOutbound md-raised"
                  @click="getBookingAssign()"
                  :disabled="!getAssignBookingCond || this.getPermission.fsireadonly.view || this.getPermission.ccicqc.view || this.getPermission.fsireadonlyforerl.view"
                  > 
                  Assign BK
                  </md-button
                >

                <md-button 
                  class="custButtonOutbound md-raised"
                  @click="getBookingUnAssign()"
                  :disabled="!getUnAssignBookingCond || this.getPermission.fsireadonly.view || this.getPermission.ccicqc.view || this.getPermission.fsireadonlyforerl.view"
                  > 
                  Un-Assign
                  </md-button
                > -->

                <!-- <md-button
                  
                  class="custButtonOutbound md-raised"
                  v-if="getPermission.acnit.view || getPermission.fsi.view"
                  @click="sendSMS()"
                  :disabled="!getWticketCond  || this.getPermission.fsireadonly.view || this.getPermission.ccicqc.view || this.getPermission.fsireadonlyforerl.view"
                  > 
                  SMS
                  </md-button
                >

                 <md-button
                  v-if="getPermission.acnit.view || getPermission.stc.view"
                  class="custButtonOutbound md-raised"
                  @click="sendSMSSTC()"
                  :disabled="!getWticketCond  || this.getPermission.fsireadonly.view || this.getPermission.ccicqc.view || this.getPermission.fsireadonlyforerl.view"
                  > 
                  STC SMS
                  </md-button
                > -->


                <!-- <md-button
                  
                  class="custButtonOutbound md-raised"
                  @click="smsLog()"
                  :disabled="!getWticketCond || this.getPermission.fsireadonly.view || this.getPermission.ccicqc.view || this.getPermission.fsireadonlyforerl.view"
                  > 
                  SMS Log
                  </md-button
                > -->

                <!-- <md-button
                  
                  class="custButtonOutbound md-raised"
                  @click="getOutbound()"
                  :disabled="!getOutboundCond || this.getPermission.fsireadonly.view || this.getPermission.ccicqc.view || this.getPermission.fsireadonlyforerl.view"
                  > 
                  Outbound
                  </md-button
                > -->

                <md-button
                  
                  class="custButtonOutbound md-raised"
                  @click="getPhotos()"
                  :disabled="!getPhotoCond || this.getPermission.fsireadonly.view || this.getPermission.ccicqc.view || this.getPermission.fsireadonlyforerl.view || this.getPermission.fsireadonlywithwgtticket.view || this.getPermission.stcoptfsireadonly.view"
                  > 
                  Photos
                  </md-button
                >
                <md-button @click="doViewUrgentCntr" class="md-raised custButton">Urgent</md-button> 


                <div class = "inputBoxButton" >
              <auto-complete-master-data-select
                                                :prepared-options="getOutboundStatus"
                                                label="Status"
                                                :init-value="searchRequest.loadStatus"
                                                :on-item-changed="handleStatusChanged"
                                                >
            </auto-complete-master-data-select>
            </div>

            

                <md-button
                  id="searchTag"
                  @click="doSearch('0')"
                  class="custButtonOutbound md-primary md-raised"
                  >Search</md-button
                >
                <md-button @click="clearSearch" class="md-raised custButtonOutbound"
                  >Clear</md-button
                >

                <md-button
                  
                  class="custButtonOutbound md-raised"
                  @click="doDownloadExcel"
                  :disabled="!getDownloadCond"
                  > 
                  Download
                  </md-button
                >

                <md-button @click="doPhotos" class="custButtonOutbound md-raised" md-menu-trigger v-if="getPermission.ccicqc.view || getPermission.acnit.view">
                  <md-icon class = "custButton">cloud_upload</md-icon>
                </md-button>

                <input
                  class = "custSearchBar"
                  type="text"
                  placeholder="Searching Term"
                  v-model="filter"
                />
     
                <md-button
                  class="md-icon-button"
                  @click="mouseLeave"
                  id="expand-button"
                >
                  <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
                  <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
                </md-button>
              <!-- </callingApiCenter> -->
            </callingApiCenter>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <md-progress-bar  v-if="isdownloadzip" id="pb" style="display:''" md-mode="indeterminate"/>

    <pagination :items="filteredRows">
      <template slot-scope="{ pageItems }">
        <md-card class="data-table-container">
          <div  class="outer-container">
            <div  class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                    <tr >
                      <th class="header-cell w2 fix"></th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['errorMsg']">
                        Error Message
                      </th>
                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['loadStatus']"
                        v-on:click="sortFunction('loadStatus')">
                        Status
                      </th>
                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['receivingWindows']"
                        v-on:click="sortFunction('receivingWindows')">
                        Rev Window
                      </th>
                      <!-- <th
                        class="header-cell center w5"
                        v-if="viewFilter['driverLP']"
                        v-on:click="sortFunction('driverLP')">
                        Plate#
                      </th> -->
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['containerNo']"
                        v-on:click="sortFunction('containerNo')">
                        Container#
                      </th>
                      <th
                        class="header-cell center w6"
                        v-if="viewFilter['chassisNo']"
                        v-on:click="sortFunction('chassisNo')">
                        Chassis#
                      </th>
                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['urgentContainer']"
                        v-on:click="sortFunction('urgentContainer')">
                        Urgent
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['ctnrType']"
                        v-on:click="sortFunction('ctnrType')">
                        CTN type
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['yard']"
                        v-on:click="sortFunction('yard')">
                        Yard Loc
                      </th>
                      <th
                        class="header-cell center w7"
                        v-if="viewFilter['photoCount'] && getPermission.ccicqc.view || getPermission.acnit.view || getPermission.fsiclerkwithloadpic.view"
                        v-on:click="sortFunction('photoCount')">
                        Loading Photo
                      </th>
                      <!-- <th
                        class="header-cell center w5"
                        v-if="viewFilter['stcSMSSend']"
                        v-on:click="sortFunction('stcSMSSend')">
                        SMS Send
                      </th> -->
                      <!-- <th
                        class="header-cell center w5"
                        v-if="viewFilter['stcSMSDriver']"
                        v-on:click="sortFunction('stcSMSDriver')">
                        Send Driver
                      </th> -->
                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['outboundRemark']"
                        v-on:click="sortFunction('outboundRemark')">
                        Remark
                      </th>
                      <th
                        class="header-cell center w10"
                        v-if="viewFilter['outboundRemark']"
                        v-on:click="sortFunction('outboundRemark')">
                        Remark
                      </th>
                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['scaleTicket']"
                        v-on:click="sortFunction('scaleTicket')">
                        Weight Ticket
                      </th>

                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['scanWt']"
                        v-on:click="sortFunction('scanWt')">
                        Input WTicket
                      </th>    
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['scaleTicket']"
                        v-on:click="sortFunction('scanWt')">
                        Ticket to SAP
                      </th>

                      <th
                        class="header-cell center w7"
                        v-if="viewFilter['scaleTicket']"
                        v-on:click="sortFunction('scanWt')">
                        Scan Weight Ticket
                      </th>
                      <th
                        class="header-cell center w4"
                        v-if="viewFilter['twDate']"
                        v-on:click="sortFunction('twStation')">
                        Scale Station (T)
                      </th>

                      <th
                        class="header-cell center w4"
                        v-if="viewFilter['twDate']"
                        v-on:click="sortFunction('twDate')">
                        Scale Date (T)
                      </th>
                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['twDate']"
                        v-on:click="sortFunction('twDate')">
                        Scale Time (T)
                      </th>
                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['twDate']"
                        v-on:click="sortFunction('twDate')">
                        Scale Time Web (T)
                      </th>
                      <th
                        class="header-cell center w4"
                        v-if="viewFilter['twYgNo']"
                        v-on:click="sortFunction('twYgNo')">
                        Yard Goat (T)
                      </th>
                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['twYgWeight']"
                        v-on:click="sortFunction('twYgWeight')">
                        Tare Weight
                      </th>
                      <th
                        class="header-cell center w2"
                        v-if="viewFilter['grade']"
                        v-on:click="sortFunction('grade')">
                        Grade
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['specGrade']"
                        v-on:click="sortFunction('specGrade')">
                        Special Grade
                      </th>
                      <th
                        class="header-cell center w2"
                        v-if="viewFilter['bales']"
                        v-on:click="sortFunction('bales')">
                        Bale
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['newSeal']"
                        v-on:click="sortFunction('newSeal')">
                        Seal No
                      </th>

                      <th
                        class="header-cell center w4"
                        v-if="viewFilter['twDate']"
                        v-on:click="sortFunction('gwStation')">
                        Scale Station (G)
                      </th>


                      <th
                        class="header-cell center w4"
                        v-if="viewFilter['twDate']"
                        v-on:click="sortFunction('gwDate')">
                        Scale Date (G)
                      </th>
                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['twDate']"
                        v-on:click="sortFunction('gwDate')">
                        Scale Time (G)
                      </th>

                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['twDate']"
                        v-on:click="sortFunction('gwDate')">
                        Scale Time Web (G)
                      </th>


                      <th
                        class="header-cell center w4"
                        v-if="viewFilter['gwYgNo']"
                        v-on:click="sortFunction('gwYgNo')">
                        Yard Goat (G)
                      </th>
                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['gwYgWeight']"
                        v-on:click="sortFunction('gwYgWeight')">
                        Gross Weight
                      </th>  
                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['weight']"
                        v-on:click="sortFunction('weight')">
                        Net Weight
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['bookingNo']"
                        v-on:click="sortFunction('bookingNo')">
                        Booking
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['ctnrCount']"
                        v-on:click="sortFunction('ctnrCount')">
                        Container Count
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['ctnrAssign']"
                        v-on:click="sortFunction('ctnrAssign')">
                        Container Assign
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['carrier']"
                        v-on:click="sortFunction('carrier2')">
                        BK Carrier
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['ibd']"
                        v-on:click="sortFunction('ibd')">
                        Custmoer order(IBD)
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['deliveryOrder']"
                        v-on:click="sortFunction('deliveryOrder')">
                        Delivery Order
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['internal']"
                        v-on:click="sortFunction('internal')">
                        Internal
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['ibs']"
                        v-on:click="sortFunction('ibs')">
                        Internal#
                      </th>
                      <th
                        class="header-cell center w4"
                        v-if="viewFilter['assignDate']"
                        v-on:click="sortFunction('assignDate')">
                        Assign Date
                      </th>
                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['assignDate']"
                        v-on:click="sortFunction('assignDate')">
                        Assign Time
                      </th>
                      <th
                        class="header-cell center w4"
                        v-if="viewFilter['assignDate']"
                        v-on:click="sortFunction('outboundDate')">
                        Outbound Date
                      </th>
                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['assignDate']"
                        v-on:click="sortFunction('outboundDate')">
                        Outbound Time
                      </th>
                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['sapStatus']"
                        v-on:click="sortFunction('sapStatus')">
                        SAP Status
                      </th>
                      <th
                        class="header-cell center w3"
                        v-if="viewFilter['carrier']"
                        v-on:click="sortFunction('carrier')">
                        Carrier
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['transloadingYard']"
                        v-on:click="sortFunction('transloadingYard')">
                        Transloading Yard
                      </th>
                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['seqNo']"
                        v-on:click="sortFunction('seqNo')">
                        Load Key
                      </th>

                      

                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['unloadInfo']"
                        >
                        Load Start Date
                      </th>

                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['unloadInfo']"
                        >
                        Load Start Time
                      </th>

                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['unloadInfo']"
                        >
                        Load End Date
                      </th>

                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['unloadInfo']"
                        >
                        Load End Time
                      </th>

                      <th
                        class="header-cell center w5"
                        v-if="viewFilter['unloadInfo']"
                        >
                        Load User
                      </th>

                      <!-- <th
                        class="header-cell center w10"
                        v-if="viewFilter['status2']"
                        >
                        Status2
                      </th> -->
                    </tr>
                  </thead>
                </table>
              </div>
              <div id = 'tableId' class="table-body" @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                    <tr class = "nthRow"
                      :key="item.seqNo"
                      v-for="item in pageItems"
                      v-bind:class="{ selected: item.selected }"
                    >
                    
                      <td class="body-cell w2 fix"
                      style="left: 0px">
                        <md-checkbox v-model="item.selected">
                          <span v-if="hasBeenChanged(item)">*</span>
                        </md-checkbox>
                      </td>
                      
                      <td class="body-cell excelBox w5 errorMessage"
                      
                       v-if="viewFilter['errorMsg']">
                       {{item.errorMsg}}
                      </td>
                      <td class="body-cell excelBox w3" v-if="viewFilter['loadStatus']" >
                        {{ item.loadStatus }}
                      </td>
                      <td class="body-cell excelBox w3" v-if="viewFilter['receivingWindows']">
                        {{ item.receivingWindows }}
                      </td>
                      <!-- <td class="body-cell excelBox w5" v-if="viewFilter['driverLP']">
                        {{ item.driverLP }}
                      </td> -->
                      <td class="body-cell excelBox w5" v-if="viewFilter['containerNo']">
                        {{ item.containerNo }}
                      </td>
                      <td class="body-cell excelBox w6" v-if="viewFilter['chassisNo']">
                        {{ item.chassisNo }}
                      </td>
                      <td class="body-cell excelBox w3" v-if="viewFilter['urgentContainer']">
                        <md-checkbox v-model="item.urgentContainer"></md-checkbox>
                        <!--{{ item.urgentContainer == true? 'X' : '' }}-->
                      </td>
                      <td class="body-cell excelBox w5" v-if="viewFilter['ctnrType']">
                        <master-data-display group="CCR_CNTRTYPE" :tag-id="item.ctnrType"/>
                      </td>
                      <td class="body-cell excelBox w5" v-if="viewFilter['yard']">
                        <div class = "spaceLine">{{item.yard}} - {{item.locationNumber}}</div>
                      </td>
                      <td class="body-cell center w7" v-if="getPermission.ccicqc.view || getPermission.acnit.view || getPermission.fsiclerkwithloadpic.view">
                        <template v-if="item.photoCount > 0 && item.scanWtLink != null">
                          <a href="" @click.prevent="toggleItemPhoto(item)">{{item.photoCount - 1}} photos</a>
                        </template>
                        <template v-else-if="item.photoCount > 0 && item.scanWtLink == null">
                          <a href="" @click.prevent="toggleItemPhoto(item)">{{item.photoCount}} photos</a>
                        </template>
                        <template v-else>
                          <span>0 photos</span>
                        </template>
                      </td>
                      <!-- <td class="body-cell excelBox w5" v-if="viewFilter['stcSMSSend']">
                        {{ item.stcSMSSend }}
                      </td> -->
                      <!-- <td class="body-cell excelBox w5" v-if="viewFilter['stcSMSDriver']">
                        {{ item.stcSMSDriver }}
                      </td> -->
                      <td class="body-cell excelBox w3" v-if="viewFilter['outboundRemark']">
                          <md-checkbox v-model="item.hasRemark" disabled></md-checkbox>
                          <!--{{ item.urgentContainer == true? 'X' : '' }}-->
                      </td>
                      <td class="body-cell excelBox w10" v-if="viewFilter['outboundRemark']">
                        {{ item.outboundRemark }}
                      </td>
                    <td class="body-cell excelBox w3" v-if="viewFilter['scaleTicket']">
                        {{ item.scaleTicket }}
                      </td>
                      <td class="body-cell excelBox w5" v-if="viewFilter['scanWt']">
                        {{ item.scanWt }}
                      </td>
                      <td class="body-cell excelBox w5" v-if="viewFilter['scanWt']">
                        {{ item.scanWt == null ? item.scaleTicket : item.scanWt }}
                      </td>

                       <td class="body-cell center w7">
                      <template v-if="item.scanWtLink != null">
                        <a href="" @click.prevent="getPhotoScanWt(item)"> 1
                          photos</a>
                      </template>
                      <template v-else>
                        <span>0 photos</span>
                      </template>
                    </td>

                      <td class="body-cell excelBox w4" v-if="viewFilter['twDate']">
                        {{ item.twStation }}
                      </td>

                      <td class="body-cell excelBox w4" v-if="viewFilter['twDate']">
                        {{ item.twDate | date }}
                      </td>
                      <td class="body-cell excelBox w3" v-if="viewFilter['twDate']">
                        {{ item.twDate | time }}
                      </td>
                      <td class="body-cell excelBox w3" v-if="viewFilter['twDate']">
                        {{ item.twDateWeb | time }}
                      </td>
                      <td class="body-cell excelBox w4" v-if="viewFilter['twYgNo']">
                        {{ item.twYgNo }}
                      </td>
                      <td class="body-cell excelBox w3" v-if="viewFilter['twYgWeight']">
                        {{ item.tareWeight == null ? item.tareWeight : parseInt(item.tareWeight) }}
                      </td>
                      <td class="body-cell excelBox w2" v-if="viewFilter['grade']">
                        {{ item.grade }}
                      </td>
                      <td class="body-cell excelBox w5" v-if="viewFilter['specGrade']">
                        {{ item.specGrade }}
                      </td>
                      <td class="body-cell excelBox w2" v-if="viewFilter['bales']">
                        {{ item.bales }}
                      </td>
                      <td class="body-cell excelBox w5" v-if="viewFilter['newSeal']">
                        {{ item.newSeal }}
                      </td>

                      <td class="body-cell excelBox w4" v-if="viewFilter['gwDate']">
                        {{ item.gwStation}}
                      </td>

                      <td class="body-cell excelBox w4" v-if="viewFilter['gwDate']">
                        {{ item.gwDate | date}}
                      </td>
                      <td class="body-cell excelBox w3" v-if="viewFilter['gwDate']">
                        {{ item.gwDate | time }}
                      </td>
                      <td class="body-cell excelBox w3" v-if="viewFilter['gwDate']">
                        {{ item.gwDateWeb | time }}
                      </td>
                      <td class="body-cell excelBox w4" v-if="viewFilter['gwYgNo']">
                        {{ item.gwYgNo }}
                      </td>
                      <td class="body-cell excelBox w3" v-if="viewFilter['gwYgWeight']">
                        {{ item.vgmWeight == null ? item.vgmWeight : parseInt(item.vgmWeight) }}
                      </td>
                      <td class="body-cell excelBox w3" v-if="viewFilter['weight']">
                        {{ item.weight == null ? item.weight : parseInt(item.weight) }}
                      </td>

                      <td class="body-cell excelBox w5" v-if="viewFilter['bookingNo']">
                        {{ item.bookingNo }}
                      </td>
                      <td class="body-cell excelBox w5" v-if="viewFilter['ctnrCount']">
                        {{ item.ctnrCount }}
                      </td>
                      <td class="body-cell excelBox w5" v-if="viewFilter['ctnrAssign']">
                        {{ item.ctnrAssign }}
                      </td>
                      <td class="body-cell excelBox w5" v-if="viewFilter['carrier2']">
                        {{ item.carrier2 }}
                      </td>
                      <td class="body-cell excelBox w5" v-if="viewFilter['ibd']">
                        {{ item.ibd }}
                      </td>


                      <td class="body-cell excelBox w5" v-if="viewFilter['deliveryOrder']">
                        {{ item.deliveryOrder }}
                      </td>
                      <td class="body-cell excelBox w5" v-if="viewFilter['ibs']">
                        {{ item.ibs }}
                      </td>
                      <td class="body-cell excelBox w4" v-if="viewFilter['assignDate']">
                        {{ item.assignDate | date }}
                      </td>
                      <td class="body-cell excelBox w3" v-if="viewFilter['assignDate']">
                        {{ item.assignDate | time}}
                      </td>
                      <td class="body-cell excelBox w4" v-if="viewFilter['outboundDate']">
                        {{ item.outboundDate | date }}
                      </td>
                      <td class="body-cell excelBox w3" v-if="viewFilter['outboundDate']">
                        {{ item.outboundDate | time}}
                      </td>
                      <td class="body-cell excelBox w3" v-if="viewFilter['sapStatus']">
                        {{ item.sapStatus}}
                      </td>
                      <td class="body-cell excelBox w3" v-if="viewFilter['carrier']">
                        {{ item.carrier }}
                      </td>
                      <td class="body-cell excelBox w5" v-if="viewFilter['transloadingYard']" >
                        {{ item.transloadingYard }}
                      </td>
                      <td class="body-cell excelBox w5" v-if="viewFilter['seqNo']">
                        {{ item.seqNo }}
                      </td>
                      
                      <td class="body-cell excelBox w5" v-if="viewFilter['unloadInfo']" >
                        {{ item.unloadStartTimeStamp | date }}
                      </td>

                      <td class="body-cell excelBox w5" v-if="viewFilter['unloadInfo']" >
                        {{ item.unloadStartTimeStamp | time }}
                      </td>

                      <td class="body-cell excelBox w5" v-if="viewFilter['unloadInfo']" >
                        {{ item.unloadEndTimeStamp | date}}
                      </td>

                      <td class="body-cell excelBox w5" v-if="viewFilter['unloadInfo']" >
                        {{ item.unloadEndTimeStamp | time}}
                      </td>

                      <td class="body-cell excelBox w5" v-if="viewFilter['unloadInfo']" >
                        {{ item.uploadMobileUser }}
                      </td>

                      <!-- <td class="body-cell excelBox w10" v-if="viewFilter['status2']" >
                        {{getMasterDataByName("CCR_STATUS2",item.status2)}}
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
  </div>
</template>

<style scoped lang="scss">
@import '../../public/chris.css';

@media print {
  #printf {
    display: none; 
  }
}

    .errorMessage {
      color: #f14668;
      text-align: left;
      padding-left: 5px;
    }

    .warningMessage {
      color: #32997f;
      text-align: left;
      padding-left: 5px;
    }


    .fix {
    left: 0;
    position: -webkit-sticky;
    position: sticky;
    background: white;
    }

    .sidebar{
      margin-top: 500px;
    }


 .material-icons.md-18 {
    font-size: 18px;
  }
  .material-icons.md-24 {
    font-size: 24px;
  }
  .material-icons.md-36 {
    font-size: 36px;
  }
  .material-icons.md-48 {
    font-size: 100px;
  }
  .material-icons.md-light {
    color: rgba(255, 255, 255, 1);
  }
  .material-icons.md-light.md-inactive {
    color: rgba(255, 255, 255, 0.3);
  }

tr:nth-child(2n) .fix {
    background: #DCE6F0;
  }

.heading1 {
    padding-top: 30px;
    padding-left: 0px;
    margin-bottom: 0;
    color: black;
    width: 100%;
    font-size: 38px;
    font-family: Roboto Slab;
    margin: auto;
  }

.heading2 {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: black;
    width: 100%;
    font-size: 20px;
    font-family: Roboto Slab;
    margin: auto;
  }

  .heading3 {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: black;
    width: 100%;
    font-size: 40px;
    font-family: Roboto Slab;
    margin: auto;
  }

.wheading2 {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: black;
    width: 100%;
    font-size: 12px;
    font-weight:200;
    font-family: Roboto Slab;
    margin: 1;
  }

  .wheading3 {
    padding-top: 0px;
    padding-left: 0px;
    margin-bottom: 0;
    color: black;
    width: 100%;
    font-size: 13px;
    font-weight: bold;
    font-family: Roboto Slab;
    margin: 1;
  }

.centerPrint {
  margin: auto;
  width: 100%;
  padding: 10px;
  text-align: center;
}


.wcenterPrint {
  margin: auto;
  width: 100%;
  padding: 3px;
  text-align: center;
}

// .item1 { grid-area: area1; }
// .item2 { grid-area: area2; }
// .item3 { grid-area: area3; }
// .item4 { grid-area: area4; }
// .item5 { grid-area: area5; }

.gcontainer {
  display: grid;
  // grid-template-areas:
  //   'area1 area1 area1 area1'
  //   'area2 area2 area2 area2 area2 area2'
  //   'area3 area3 area3 area3 area3 area3'
  //   'area4 area4 area4 area4 area4 area4'
  //   'area5 area5 area5 area5 area5 area5';
  grid-gap: 5px;
  // background-color: #2196F3;
  padding: 4x;
  text-align: center;
  font-size: 30px;
}

.hContainer {
  display: flex;
  flex-direction: row;
  // background-color:grey;
}

.hContainer div {
  margin: 2px;
  width: 250px;
  text-align: center;
  line-height: 28px;
  font-size: 20px;
  // background-color:lightpink;
}

.fContainer {
  display: flex;
  flex-direction: row;
  // background-color:grey;
}

.fContainer div {

  margin: 2px;
  width: 150px;
  text-align: center;
  line-height: 20px;
  font-size: 15px;
  font-family: Arial, Helvetica, sans-serif;
  // background-color:lightpink;
}


#signature {
  width:80%;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 10px;
  height: 80px;
  margin-top: 30px;
  margin-left: 50px;
}
#signature th{
  font-family: Arial;
  text-align: left;

}
#signature td{
  // padding: 10px;
  font-family: Arial;
  text-align: left;
}

.sameLine {
    display: inline-block !important;
}

.layout1 {
    padding-bottom: 1px;
    width: 92%;
    line-height: 1.5;
    color: #555555;
    font-family: Roboto Slab;
    margin: auto;
  }


.layoutHalf1{
      display:inline-block;
      padding-top: 7px;
      padding-bottom: 7px;
      width: 50%;
      line-height: 1.5;
      color: #555555;
      font-family: Roboto Slab;
      margin: auto;
      padding-left: 15px;
  }


  .custButtonOutbound {
    margin: 10px;
    width: 65px ;
    height: 35px ;
    line-height: 20px ;
    font-size: 0.7rem ;
  }

.custButtonFilter {
    margin: 10px;
    width: 120px ;
    height: 50px ;
    line-height: 20px ;
    font-size: 0.8rem ;
  }

.inputBoxSpace {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    width: 200px;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }

  .inputBoxSpaceWide {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    width: 400px;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }

.inputBoxDouble {
    width: 400px;
    justify-content: space-around;
    display: flex;
  flex-direction: row;
  }

  .inputBoxOutbound {
    border: 1px solid #cacbcc;
    border-radius: px;
    color: #29303b;
    font-size: 12px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }

  .inputBoxButton {
    width: 160px;
    display: inline-block;
    padding: 0px 10px;
    
    // border: 1px solid #cacbcc;
    // border-radius: 5px;
    // color: #29303b;
    // font-size: 12px;
    // height: auto;
    // line-height: 0.5em;
    // padding: 5px 5px 5px 5px;
    // margin-top: 6px;
  }
  
  .inputBoxOutbound:hover {
    border: 2px solid #448aff;
    border-radius: 5px;
    color: #29303b;
    font-size: 12px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
    background-color: #e0eff7;
  }

.cl .md-field{
    display: inline-block !important;
    width: auto;
    margin-bottom: 10px;
    padding-top:10px;
}

.cl .md-field .md-input {
    font-size: 14px !important;
}

.custSearchBar {
  height: 35px;
  margin: 10px !important;
  vertical-align:top;
}

.selected.selected {
    background:yellow;
  }

.space {
  margin-top: 20px;
}





</style>

<script>
/* eslint-disable no-plusplus */
import { mapGetters } from "vuex";
import sort from "fast-sort";
import dateFormat from "../utils/dateFormat";
//import api from "../api";
import { newAPIPost } from '../api/index.js';
import parseXls from "../utils/parseXls";
import callingApiCenter from "../components/CallingApiCenter.vue";
import OutboundForm from '../components/OutboundScale';
import OutboundUploadForm from '../components/OutboundUploadForm.vue';
import DoubleLine from '../components/DoubleLine.vue';
import moment from 'moment';
import WindowPortal from '../components/WindowPortal.vue';
// import TransferTk from '../components/TransferTk.vue';
// import OutboundBooking from '../components/OutboundBooking.vue';
// import DriverSMSForm from "../components/DriverSMSForm.vue";
// import Test from "../components/STCDriverSMSForm.vue";
import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import QrcodeVue from 'qrcode.vue';
import LoadListForm from '../components/LoadListForm.vue';
import UrgentContainerList from "../components/UrgentContainerList.vue";
import OutboundRemarkForm from '../components/OutboundRemarkForm.vue';


const getScaleControlSearch = () => ({
    mode: "list",
    appName: "SCALE_OUT"
  });


const getInitSearch = () => ({
  salesOffice: null,
  transloadingYard: '1010001',
  receivingWindows: null,
  loadStatus: null,
  seqNo: null,
  scaleTicket: null,
  scanWt: null,
  // driverLP: null,
  containerNo: null,
  chassisNo: null,
  bookingNo: null,
  ibd: null,
  twDate: {
      startDate: null,
      endDate: null,
    },
  gwDate: {
      startDate: null,
      endDate: null,
    },
  carrier: null,
  carrier2: null,
  sealNumber: null,
  sealUpdateDate: {
     startDate: null,
     endDate: null
  },
  fulllist: null,
});


const getInitView = () => ({
  loadStatus: true,
  salesOffice: true,
  transloadingYard: true,
  receivingWindows: true,
  seqNo: true,
  // driverLP: true,
  containerNo: true,
  chassisNo: true,
  ctnrType: true,
  yard: true,
  photoCount: true,
  // stcSMSSend: true,
  // stcSMSDriver: true,
  locationNumber: true,
  bookingNo: true,
  ibd: true,
  carrier: true,
  carrier2: true,
  scaleTicket: true,
  scanWt: true,
  twDate: true,
  twYgNo: true,
  twYgWeight: true,
  gwYgNo: true,
  gwYgWeight: true,
  gwDate: true,
  weight: true,
  bales: true,
  newSeal: true,
  grade: true,
  specGrade: true,
  deliveryOrder: true,
  ibs: true,
  assignDate: true,
  outboundDate: true,
  sapStatus: true,
  unloadInfo: true,
  ctnrCount: true,
  ctnrAssign: true,
  // status2: true,
  urgentContainer: true,
  outboundRemark: true,
});



const getInitEdit = () => ({
  mode : null,
//   apptDate: false,
//   inboundShipment: false,
//   block: false,
//   inboundStatus: false,
//   noShow: false,
//   externalTrucker: false,
});

export default {
  data: () => ({
    searchRequest: getInitSearch(),
    dialog: {
      isShowing: false,
    },
    weightTicketStatus: false,
    weightTicketItem: [],
    items: [],
    scalecontrolSearch: getScaleControlSearch(),
    scalecontrol: [],
    sideBar: false,
    isFilterModalShowing:false,
    isPictureModalShowing: false,
    photos: [],
    edit: getInitEdit(),
    filterConfirmed: false,
    modalMessage: "",
    isWarning: false,
    active: false,
    containerCopy: false,
    filter: "",
    notifyActive: false,
    notifyMessage: null,
    viewFilter: getInitView(),
    isAblePrint: false,
    photoZipFileName: '',
    filePrefixForEachFile: '',
    isLoading: false,
    isdownloadzip: false,
    trimOption: [
      "scaleTicket",
      "scanWt",
      // "driverLP",
      "containerNo",
      "chassisNo",
      "bookingNo",
      "ibd",
      "sealNumber"
    ],
    allowFullSearch: false,
    loaded_recwin: [],
}),


  components: {
    callingApiCenter,
    OutboundForm,
    OutboundUploadForm,
    WindowPortal,
    // TransferTk,
    // OutboundBooking,
    // DriverSMSForm,
    // Test,
    QrcodeVue,
    LoadListForm,
    UrgentContainerList,
    OutboundRemarkForm,
  },

  watch: {
    getOutboundsList(val) {
      this.updateItems(val);
    },
    // eslint-disable-next-line
    "searchRequest.teams"() {
      this.searchRequest.users = [];
    },
    notifyActive(val) {
        if (val == false)
        {
          this.notifyMessage = null;
        }
    },


  },

  computed: {
    ...mapGetters([
      "getOutboundsList",
      "getMasterDataName",
      "getMasterDataByGroup",
      "getMasterDataAsSelectOptionByGroup",
      "getPermission",
      "getUserProfile",
      "getRole",
    ]),

    


    filteredRows() {
      return this.items.filter((row) => {
        const term = this.filter.toUpperCase().trim();
        return (
          this.includeNull(row.seqNo).includes(term) ||
          // this.includeNull(row.driverLP).includes(term) ||
          this.includeNull(row.containerNo).includes(term) ||
          this.includeNull(row.chassisNo).includes(term) ||
          this.includeNull(row.scaleTicket).includes(term) ||
          this.includeNull(row.scanWt).includes(term) ||
          this.includeNull(row.deliveryOrder).includes(term) ||
          this.includeNull(row.bookingNo).includes(term) ||
          this.includeNull(row.specGrade).includes(term) 
        );
      });
    },


    getOutboundStatus() {
      return [
        {
          id: 'EPT',
          name: 'EMPTY',
        },
        {
          id: 'LD',
          name: 'LOADED',
        },
      ]
    },

    getSelectedItems() {
      return _(this.items).filter((it) => it.selected);
    },

    getPhotoCond() {
      return _(this.items).filter((it) => it.selected).length === 1;
    },

    getPrintCond(){
    //   const items = this.getSelectedItems;
    //   if (items.length === 1 && this.isAblePrint == true)
    //   {
    //       return true
    //   }
    //   else
    //   {
    //     return false
    //   }
    },


    getSaveCond() {
      const editItem = this.items.filter(it  => this.hasBeenChanged(it));
      if (editItem.length === 0) return false;
    
    },

    getTWScaledCond() {
      
      const item = _(this.items).filter((it) => it.selected);
      const sapStatus = _(this.items).filter((it) => it.sapStatus != 'X');
      if (sapStatus.length == 0) return false
      return item.length === 1 && item[0].loadStatus == 'EPT'
      // return item.length === 1 
    },

    getUploadCond() {
      
      const item = _(this.items).filter((it) => it.selected);
      const sapStatus = _(this.items).filter((it) => it.sapStatus != 'X');
      if (sapStatus.length == 0) return false
      return item.length === 1 && item[0].tareWeight != null
    },


    getGWScaledCond() {
      
      const item = _(this.items).filter((it) => it.selected);
      const sapStatus = _(this.items).filter((it) => it.sapStatus != 'X');
      if (sapStatus.length == 0) return false
      return item.length === 1 && item[0].tareWeight != null 
    },

    getWticketCond() {
      const item = _(this.items).filter((it) => it.selected);
      return item.length === 1 && item[0].tareWeight != null && item[0].grade != null && item[0].vgmWeight != null && item[0].weight > 0 
    },

    getRemarkCond() {
      const item = _(this.items).filter((it) => it.selected);
      return item.length === 1
    },

    getAssignBookingCond() {

      const items = _(this.items).filter((it) => it.selected);
      const LD = _(this.items).filter((it) => it.loadStatus == 'ASN');
      if (LD.length != 0) return false;
      const weighted = _(items).filter((it) => it.weight != null);
      if (items.length == 0) return false
      const ctnrType = [...new Set(items.map(s => s.ctnrType))];
      const grade = [...new Set(items.map(s => s.grade))];
      const carrier = [...new Set(items.map(s => s.carrier))];
      // carrier.length === 1
      const sapStatus = _(this.items).filter((it) => it.sapStatus != 'X');
      if (sapStatus.length == 0) return false
      console.log("grade: " + grade + ":" + grade.length + " ctnrType: " + ctnrType + ":" + ctnrType.length);
      return items.length === weighted.length && ctnrType.length === 1 && grade.length === 1
    
    },

    getUnAssignBookingCond() {   
      const item = _(this.items).filter((it) => it.selected);
      const sapStatus = _(this.items).filter((it) => it.sapStatus != 'X');
      if (sapStatus.length == 0) return false
      return item.length === 1 && item[0].loadStatus == 'ASN'

    },

    getOutboundCond() {
      const item = _(this.items).filter((it) => it.selected);
      if (item.length === 0) return false
      const ctnrType = [...new Set(item.map(s => s.loadStatus))];
      const sapStatus = _(this.items).filter((it) => it.sapStatus != 'X');
      if (sapStatus.length == 0) return false
      return ctnrType.length === 1 && item[0].loadStatus == 'ASN' 
        && ( item[0].grade != null || item[0].bales != null || item[0].newSeal != null )
        && item[0].weight > 1
    },

    getDownloadCond() {
      
      const item = _(this.items).filter((it) => it.selected);
      if (item.length == 0 && this.items.length != 0) return this.items;

    },

    notRemarkException() {
       const item = _(this.items).filter((it) => it.selected);
       if (item.length == 1)
       {
          if (this.allowFullSearch && item[0].loadStatus != 'LD' && item[0].loadStatus != 'EPT')
          {
             return true;
          } else {
             return false;
          }
       } else {
         return true;
       }
    },

  },

  async mounted() {
    console.log('Windows Version');
    console.log(window.appVersion);
    console.log(this.getMasterDataAsSelectOptionByGroup('GST_LOAD_STATUS'));
      
    this.$el.querySelector("#expand-button").click();
    const cachedSearchRequest = this.$store.state.outbound.searchRequest;
    if (cachedSearchRequest) {
      this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
    }
    // this.searchRequest.salesOffice = this.getUserProfile.driverGroup;
    const element = this.$el.querySelector('.inputBoxOutbound');
    //console.log(element);

    this.searchRequest.salesOffice = 'LGB';
    if (this.getUserProfile.recWindow != null && this.getUserProfile.recWindow != "")
    {
       if (this.getUserProfile.recWindow == "99")
       {
           this.searchRequest.receivingWindows = "185"    
       } else {
           this.searchRequest.receivingWindows = this.getUserProfile.recWindow;
       }
    } else {
      this.searchRequest.receivingWindows = this.getUserProfile.recWindow;
    }
    if (this.getUserProfile != null && this.getUserProfile.recWindow == "99")
    {
       this.allowFullSearch = true;
    } else {
       this.allowFullSearch = false;
    }

    var p_loaded_recwin = this.getMasterDataByGroup('REC_WINDOW');
    if (p_loaded_recwin.length > 0)
    {
        if (!this.getPermission.stc.view)
        {
           this.loaded_recwin = p_loaded_recwin.filter( it => it.tagName != 'STC');
        } else {
           this.loaded_recwin = p_loaded_recwin;
        }
        console.log(`inbound rec win1 : ${JSON.stringify(this.loaded_recwin)}`);

    } else {
      //this.inbound_recwin = api.post('/api/w/masterData', {groups: ['REC_WINDOW']}).filter( it => it.tagName != 'STC');
      //api.post('/api/w/masterData', {groups: ['REC_WINDOW']})
      newAPIPost('/api/w/masterData', {groups: ['REC_WINDOW']})
      .then((res) => {
          p_loaded_recwin = res.filter(it => it.tagName != 'STC' && it.active);
          p_loaded_recwin.forEach((it) => {
            it.id = it.tagId;
            it.name = it.tagName;
            if (this.getPermission.stc.view)
            {
              this.loaded_recwin.push(it);
            }
          })
          console.log(`inbound rec win: ${JSON.stringify(this.inbound_recwin)}`);
      });
    }

  },

  methods: {

    trimTool(ent) {
      return ent == null ? null : ent.trim()
    },

    handleWindowsChanged(id) {
        this.searchRequest.receivingWindows = id;
    },

    handleStatusChanged(id) {
      this.searchRequest.loadStatus = id;
      if (id != 'OU')
      {
        this.searchRequest.gwDate.startDate = null;
        this.searchRequest.gwDate.endDate = null;
      }
      else
      {
        //console.log("outbound gw start date: " + Date());
        this.searchRequest.gwDate.endDate = this.convertDateForDatePicker(Date(),0);
        this.searchRequest.gwDate.startDate = this.convertDateForDatePicker(Date(), -90);

      }
    },

    handleCarrierChanged(id) {
      this.searchRequest.carrier = id;
    },

    handleSealNumberChanged(id) {
      this.searchRequest.sealNumber = id; 
    },

    hasBeenChanged(item) {

        const lhs = _(this.getOutboundsList)
          .find(it => it.seqNo === item.seqNo);

        if (lhs) {
          return (lhs.seqNo !== item.seqNo)
        }
        return false;
      },


    sortFunction(sortFiled) {
      const sorted = sort(this.items).asc(sortFiled);
      this.sortStatus = !this.sortStatus;
      if (this.sortStatus) {
        this.items = sorted;
      } else {
        this.items = sorted.reverse();
      }
    },

    sortSingleWay(sortFiled) {
      sort(this.items).asc(sortFiled);
    },

    sortM(...args) {
      sort(this.items).asc(args);
    },

    includeNull(field) {
      return field == null ? "" : field;
    },

    mouseOver: function () {
      this.active = true;
    },

    mouseLeave: function () {
      this.active = !this.active;
    },

    getMasterDataByName(group, tagId) {
      console.log("get master data name: " + group + ", " + tagId);
      if (!tagId) {
        return "";
      }
      console.log("master name: " + this.getMasterDataName(group, tagId));
      return this.getMasterDataName(group, tagId);
      //return "";
    },

    updateItems(itemsSource, isDisplay = false) {
      $('#tableId').scrollLeft(0);
      var items = JSON.parse(JSON.stringify(itemsSource));
      console.log("outbound items before add: " + JSON.stringify(items));
      items.forEach((it) => {
        it.backGroud = false;
        it.selected = false;
        it.editing = false;
        if (it.outboundRemark != null && it.outboundRemark != '')
        {
           it.hasRemark = true;
        }
      });
      console.log("outbound items: " + JSON.stringify(items));
      this.items = items;
      if (this.notifyMessage != null)
          {
            this.notifyActive = true;
            
          }
    },


    handleScroll(e) {
      $(this.$el.querySelector(".table-header")).offset({
        left: -1 * (e.target.scrollLeft - $(".outer-container").offset().left),
      });
    },


    async doSave(){
    //   if (this.edit.mode == "APPTG")
    //   {
    //     this.saveApptG();
    //   }
    },

    doViewUrgentCntr(){
        this.$refs.ViewUrgentContainerList.openDialog();
      },



    saveApptC()
    {
    //   const editItem = this.items.filter(it  => this.hasBeenChanged(it));
    //     var result = [];

    //     const allApiCalls = _(editItem).chain().map((it) => {
    //               return new Promise((resolve) => {
    //                 api.post(
    //                   '/api/w/fsi/WebSaveInbound',
    //                   {
    //                     mode: 'APPTC',
    //                     apptNo: it.apptNo,
    //                     apptSeq: it.apptSeq,
    //                     inboundShipment : it.inboundShipment,
    //                     inboundStatus: it.inboundStatus,
    //                     inboundSeq: it.inboundSeq,
    //                     moveInBy: it.moveInBy,
    //                     driverPh: it.driverPh,
    //                     driverLP: it.driverLP,
    //                     containerNo: it.containerNo,
    //                     ciDate: it.ciDate,
    //                     loadRemark: it.loadRemark,
    //                   },
    //                 ).then((data) => {
    //                     // result.push(data);
    //                     // resolve(data);
    //                     it.errorMsg = data;
    //                     resolve(it)
    //                   }).catch((err) => {
    //                     // result.push(err.messages.join(';'));
    //                     // resolve(err);
    //                     it.errorMsg = err.messages.join(';');
    //                     resolve(it)
    //                   });
    //               });
    //             }).value();

    //             Promise.all(allApiCalls).then((results) => {
    //               const resultData = [];
    //               _(results)
    //                 .each(it => resultData.push(it));
    //                 this.$store.commit("updateInbound", resultData);
    //                 this.updateItems(this.getInboundsList, true);
    //                 this.viewFilter.errorMsg = true;
    //                 this.edit = getInitEdit();
    //                 this.notifyActive = true;
    //                 const hasError = _(results).filter((it) => it.errorMsg != null);
    //                 if (hasError.length == 0)
    //                 {
    //                   this.notifyMessage = "Below containers have been updated!"
    //                 }
    //                 else
    //                 {
    //                   this.notifyMessage = "Some of the items have not been saved , please check error message to learn detial! "
    //                 }
                    
                    
    //             });
    },




    async doSearch(id) {
      this.$store.commit("clearApiError");
      // this.notifyActive = false;
      // this.notifyMessage = null;
      // this.isAblePrint = false;

      if (this.searchRequest.salesOffice == null || this.searchRequest.salesOffice === '')
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Can not get sale office info , please refresh your page!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
      }


      if (this.searchRequest.transloadingYard == null || this.searchRequest.transloadingYard === '')
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Transloading Yard is required!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
      }

      //********Development use. Remove Before Push*********      
      // if (window.location.host == "localhost:8080")  
      // {
      //   this.searchRequest.gwDate.startDate = "2020-06-09"
      //   this.searchRequest.gwDate.endDate = "2022-06-09"
      // }
      //**************************************************** 
      
      if (this.searchRequest.receivingWindows == null || this.searchRequest.receivingWindows === '')
      {
        this.$buefy.notification.open({
                    duration: 5000,
                    message: `Receving Windows is required!`,
                    position: 'is-top-right',
                    type: 'is-danger',
                    hasIcon: true
                })
        return
      }

      for (const el of this.trimOption) {
        this.searchRequest[el] = this.trimTool(this.searchRequest[el]);
      }

      if (this.getUserProfile != null && this.getUserProfile.recWindow == "99")
      {
         this.searchRequest.fulllist = true;
      }
      
      var req = this.searchRequest;
      this.items = [];
      if (id == '0')
      {
        this.isAblePrint = true;
        this.viewFilter = getInitView();
        this.edit = getInitEdit();
      }

      await this.$store.dispatch("outboundsList", req);
      this.active = false;
    },

    clearSearch() {
      
      _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear'))
          .each((it) => {
            it.click();
          });
      this.$nextTick(() => {
          this.searchRequest = getInitSearch();
          this.searchRequest.salesOffice = 'LGB';
          this.items = this.getOutboundsList;
          this.updateItems(this.getOutboundsList);
          this.edit = getInitEdit();
        });
      // this.searchRequest.salesOffice = this.getUserProfile.driverGroup;
      
    },

    outboundRemark() {
      console.log('Outbound Remark');
      this.$refs.OutboundRemarkForm.openDialog(this.getSelectedItems[0]);
      //this.doSearch('0');
    },

    updateRemark(remark) {
      console.log("select item: " + JSON.stringify(this.getSelectedItems[0]));
      console.log("return remark: " + remark);
      const p_seqno = this.getSelectedItems[0].seqNo;
      var p_items = this.items;
      p_items.forEach(
        (it) => {
            if (it.seqNo == p_seqno)
            {
                it.outboundRemark = remark;
                it.hasRemark = true;
                //return;
            }
        }
      )
      this.items = p_items;
      // const p_apptNo = this.getSelectedItems[0].apptNo;
      // const p_ibs = this.getSelectedItems[0].inboundShipment;
      // this.items.forEach(
      //    (it) => {
      //        if (it.apptNo == p_apptNo && it.inboundShipment == p_ibs) {
      //            it.loadRemark = remark;
      //            //console.log("get the item: " + JSON.stringify(it));
      //            return;
      //        }
      //    }
      // )
    }, 

    getDisplay(group, tagId) {
      if (!tagId) {
        return "";
      }
      return this.getMasterDataName(group, tagId) || this.tagId;
    },
    //duplicate the method for downexcel and just in case
    getDisplay2(group, tagId) {
      if (!tagId) {
        return "";
      }
      return this.getMasterDataName(group, tagId) || tagId;
    },

    convertDateForDatePicker(date,offset) {
        var day = "";
        var month = "";
        var year = "";
        var newdate = new Date();
        if (date) {
           //console.log("date input: " + date);
          //  if (date.toString().indexOf("T") > 0) {
          //     dateString = date.toString().substr(1, date.toString().indexOf("T") - 1);
          //     console.log("convert date for date picker: " + Date(dateString).getMonth());
          //     return moment(dateString);      
          //  }   
          //  else {
          //     return date;
          //  }
          var processDate = new Date(date);
          if (offset && offset != 0)
             processDate.setDate(newdate.getDate() - 90);
          console.log("process date after adjusted: " + processDate);   
          year = processDate.getFullYear();
          month = processDate.getMonth() + 1;
          day = processDate.getDate();
          if (month && month.toString().length < 2) {
             month = "0" + month;
          }
          if (day && day.toString().length < 2) {
             day = "0" + day;
          }
          //console.log("date (" + type + ") input in format: " +  month + "/" + day + "/" + year );
          return month + "/" + day + "/" + year;
        }
        else {
          //console.log("no date (" + type + ") input in format: ");
          return date;
        }
    },

    convertDateForDatePicker(date,offset) {
        var day = "";
        var month = "";
        var year = "";
        var newdate = new Date();
        if (date) {
           //console.log("date input: " + date);
          //  if (date.toString().indexOf("T") > 0) {
          //     dateString = date.toString().substr(1, date.toString().indexOf("T") - 1);
          //     console.log("convert date for date picker: " + Date(dateString).getMonth());
          //     return moment(dateString);      
          //  }   
          //  else {
          //     return date;
          //  }
          var processDate = new Date(date);
          if (offset && offset != 0)
             processDate.setDate(newdate.getDate() - 90);
          console.log("process date after adjusted: " + processDate);   
          year = processDate.getFullYear();
          month = processDate.getMonth() + 1;
          day = processDate.getDate();
          if (month && month.toString().length < 2) {
             month = "0" + month;
          }
          if (day && day.toString().length < 2) {
             day = "0" + day;
          }
          //console.log("date (" + type + ") input in format: " +  month + "/" + day + "/" + year );
          return month + "/" + day + "/" + year;
        }
        else {
          //console.log("no date (" + type + ") input in format: ");
          return date;
        }
    },


    async setGrossWeight(item){
    //   const change = this.getSelectedItems[0];
    //   change.gwStation = null;
    //   change.vgmWeight = item.nw;
    //   change.gwTime = item.time;
    //   change.gwStation = item.scale;
    //   change.gwDate = item.date;
    },

    async setTareWeight(item) {
      // const change = this.getSelectedItems[0];
      // change.tareWeight = item.nw;
      // change.twDate = item.date;
      // change.twTime = item.time;
      // change.twStation = item.scale;
    },

    async onfresh(id, ticket, mode, loads) {
      console.log(`${id} , ${ticket} , ${mode}`);
      this.notifyMessage =  null;

      switch(mode)
      {
        case 'STR':
        this.notifyMessage = `Load ${id} has been scaled tw with scale ticket: ${ticket}.`;
        break;

        case 'SWR':
        this.notifyMessage = `Load ${id} with scale ticket: ${ticket} has been scaled gw.`;
        break;

        case 'ASN':
        this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
        break;

        case 'UASN':
        this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
        break;

        default:
          break;
      }
      
      this.doSearch();
    },

    // async updateSend(send, loadkey, driverId)
    // {
    //   console.log("send: " + send + " loadkey: " + loadkey);
    //   var selectedItem = _(this.items).find(it => it.seqNo == loadkey)
    //   console.log("selecteditem: " + selectedItem);
    //   if (selectedItem != null)
    //      selectedItem.stcSMSSend = send;
    //      selectedItem.stcSMSDriver = driverId;
    // },

    weightTicket(){
      const item = _(this.items).filter((it) => it.selected);
      this.weightTicketItem = item[0];
      if (this.weightTicketItem.receivingWindows == '185' || this.weightTicketItem.receivingWindows == '187' || this.weightTicketItem.receivingWindows == '202')
      {
        this.weightTicketItem.company = 'FSI Long Beach'
        this.weightTicketItem.add1 = '1495 Judson Ave Long Beach, CA 90813'
        this.weightTicketItem.add2 = 'Tel:(562)495-1936'
        this.weightTicketItem.weightmaster4 = 'Consignee: FSI TRANSLOADING INC.'
        this.weightTicketItem.weightmaster5 = 'Weighed at: 1465 Judson Ave., Long Beach, CA 90813 USA'
      }

      if (this.weightTicketItem.receivingWindows == '186' || this.weightTicketItem.receivingWindows == '188' || this.weightTicketItem.receivingWindows == '203')
      {
        this.weightTicketItem.company = 'FSI Wilmington' 
        this.weightTicketItem.add1 = '936 Mahar Avenue, Wilmington, CA 90744'
        this.weightTicketItem.add2 = 'Tel:(562)495-1936'   
        this.weightTicketItem.weightmaster4 = 'Consignee: FSI TRANSLOADING INC.'
        this.weightTicketItem.weightmaster5 = 'Weighed at: 936 Mahar Ave., Wilmington CA 90744 USA' 
      }

      this.weightTicketItem.weightmaster1 = 'WEIGHTMASTER CERTIFICATE' 
      this.weightTicketItem.weightmaster2 = 'THIS IS TO CERTIFY that the following described commodity was weighed, measured, or counted by a weighmaster, whose signature is on this certificate, who is a recognized authority of accuracy, as prescribed by Chapter 7 (commencing with Section 12700) of Division 5 of the California business and Professions Code, administered by the Division of Measurement Standards of the California Department of Food and Agriculture.' ;
      this.weightTicketItem.weightmaster3 = 'LICENSE NO.: 014950'

      // this.weightTicketItem.apptDateD = dateFormat.date(this.weightTicketItem.apptDate)
      // this.weightTicketItem.ciDateT = dateFormat.time(this.weightTicketItem.ciDate)
 
      this.weightTicketItem.ctnrTypeD = this.getDisplay('CCR_CNTRTYPE', this.weightTicketItem.ctnrType)


      // const doc = new jsPDF()
      // doc.text(20,20,this.weightTicketItem.company)  
      // doc.text(20,30,this.weightTicketItem.add1)
      // doc.text(20,40,this.weightTicketItem.add2)
      // doc.text(20,50,'Onbound')
      // doc.text(20,60,'Receiving Window:'+ this.weightTicketItem.receivingWindows)
      // doc.text(20,70,'Weight Ticket:'+ this.weightTicketItem.scaleTicket + '/' + this.weightTicketItem.scanWt)
      // doc.autoTable({
      //   margin: {top: 80},
      //   head: [['Load Key','Chassis#','Container#','CTN Type','Yard Loc']],
      //   body:[
      //       [this.weightTicketItem.seqNo, 
      //       this.weightTicketItem.chassisNo,
      //       this.weightTicketItem.containerNo,
      //       this.weightTicketItem.ctnrTypeD,
      //       this.weightTicketItem.locationNumber
      //   ]],})

      // doc.autoTable({
      //   head: [['Grade','Bale Count','Seal','SCAC','Booking']],
      //   body:[
      //       [this.weightTicketItem.grade, 
      //       this.weightTicketItem.bales,
      //       this.weightTicketItem.newSeal,
      //       this.weightTicketItem.carrier2,
      //       this.weightTicketItem.bookingNo
      //   ]],})

      //   doc.autoTable({     
      //   head: [['Scale Date(T)','Yard Goat(T)','YG Weight(T)','Tare Weight','']],
      //   body:[
      //       [this.weightTicketItem.twDate, 
      //       this.weightTicketItem.twYgNo,
      //       this.weightTicketItem.twYgWeight,
      //       this.weightTicketItem.tareWeight,
      //       ''
      //   ]],})

      //   doc.autoTable({
      //   head: [['Scale Date(G)','Yard Goat(G)','YG Weight(G)','Gross Weight','']],
      //   body:[
      //       [this.weightTicketItem.gwDate, 
      //       this.weightTicketItem.gwYgNo,
      //       this.weightTicketItem.gwYgWeight,
      //       this.weightTicketItem.vgmWeight,
      //       ''
      //   ]],})

      // doc.text(140,170,'Net Weight: '+ this.weightTicketItem.weight)

      // var PDFBase64 = btoa(doc.output())
      // api.post('/api/w/uploadPDF', {
      // fileName: this.weightTicketItem.seqNo,
      // imageBase64: PDFBase64,
      // folder: "WTicket"
      // })


      this.weightTicketStatus = true;
    },



    toggleCreate() {
      this.$refs.CreateForm.openDialog(this.searchRequest);
    },

    async getScaleWeight(mode){

      // api.post('/api/w/app/list', this.scalecontrolSearch).then((scalectl) => {
      //   this.scalecontrol = scalectl;

    
      //this.scalecontrol = await api.post('/api/w/app/list', this.scalecontrolSearch);
      this.scalecontrol = await newAPIPost('/api/w/app/list', this.scalecontrolSearch);
      const scale0 = this.scalecontrol[0];
      const scale1 = this.scalecontrol[1];
      const scale2 = this.scalecontrol[2];
      const scale3 = this.scalecontrol[3];
      const scale4 = this.scalecontrol[4];


      const selectedItem = this.getSelectedItems[0];
      console.log(mode);

      if (mode == 'GW')
      {
        this.$refs.ScaleGrossWeight.openDialog(selectedItem, scale0, scale1, scale2, scale3, scale4);
      }
      
      if (mode == 'TW')
      {
        this.$refs.ScaleTareWeight.openDialog(selectedItem, scale0, scale1, scale2, scale3, scale4);
      }
      
    },

    getBaleUpload(){
      const selectedItem = this.getSelectedItems[0];
      this.$refs.OutboundUploadForm.openDialog(selectedItem);
    },

    // sendSMSSTC() {
    //   const editItem = this.items.filter(it => it.selected === true);
    //   console.log("edititem: " + JSON.stringify(editItem));
    //   this.$refs.STCDriverSMSForm.openDialog(editItem);
    // },
 
    // sendSMS(){
    //    //const change = this.getSelectedItems[0];
    //    const editItem = this.items.filter(it  => it.selected === true);
    //    console.log("editItem length: " + editItem.length);
    //    if (editItem.length > 0)
    //    {
    //       this.weightTicket();

    //       console.log("select item container#: " + editItem[0].containerNo);
    //       //console.log("editItem: " + editItem[0].moveInBy + " phonenum: " + editItem[0].driverPh + " IBS: " + editItem[0].inboundShipment);
    //       const url = "https://named-account-web-dev.s3.us-west-2.amazonaws.com/PDF/WTicket/" + editItem[0].seqNo + ".pdf";
    //       //const url = "https://named-account-web-dev.s3.us-west-2.amazonaws.com/PDF/WTicket/C000009937.pdf";
    //       console.log("url: " + url);
    //       // fetch(url)
    //       // .then( response => {
    //       //    if  (response.statusText === "OK") {
    //       //        console.log("url existed");
    //              this.$refs.DriverSMSForm.openDialog(editItem);
    //       //    }
    //       //    else
    //       //    {
    //       //        console.log("url not found");
    //       //        this.$buefy.notification.open({
    //       //              duration: 5000,
    //       //              message: `Weight Ticket Link is not ready!`,
    //       //              position: 'is-top-right',
    //       //              type: 'is-danger',
    //       //              hasIcon: true
    //       //         })
    //       //    }
    //       // }

    //       // )


    //       /*
    //       if (!UrlExists(url)){
    //          this.$buefy.notification.open({
    //                   duration: 5000,
    //                   message: `Weight Ticket Link is not ready!`,
    //                   position: 'is-top-right',
    //                   type: 'is-danger',
    //                   hasIcon: true
    //               })
    //       return
    //       };
    //       this.$refs.DriverSMSForm.openDialog(editItem);
    //       */
    //    }
    //    else
    //    {
    //       alert("Please select at least one entry!");
    //    }
    // },

    // smsLog(){
    //    const change = this.getSelectedItems[0];
    //    const editItem = this.items.filter(it  => it.selected === true);
    //    console.log("editItem length: " + editItem.length);
    //    console.log("select item trucker name: " + _(this.items[0]).trucker_name);
    //    console.log("editItem: " + editItem[0].moveInBy + " phonenum: " + editItem[0].driverPh + " IBS: " + editItem[0].inboundShipment);
    //    this.$refs.DriverSMSLogForm.openDialog(editItem);
    // },

    // getBookingAssign() {
    //   const loads = this.getSelectedItems
    //   this.$refs.OutboundBooking.openDialog(loads);
    // },

  
    // getBookingUnAssign() {
    //     if (!window.confirm('Unassign Selected Items?')) {
    //       return;
    //     }
        
    //   const load = this.getSelectedItems
    //   const office = 'LGB'
    //   const si = this.getSelectedItems[0].deliveryOrder
    //   const obk = this.getSelectedItems[0].bookObl
    //   const ibds = this.getSelectedItems[0].ibs
    //   const usr = 'GST_SYSTEM'
    //   const seqn = this.getSelectedItems[0].seqNo
    //   console.log("Set Unassign");
    //   const request = {
    //     salesOffice: office,
    //     deliveryOrder: si,
    //     ibs: ibds,
    //     user: usr,
    //     seqNo: seqn,
    //   };

    //   console.log(JSON.stringify(request));
    //   api.post("/api/w/DOs/WebUnAssignBooking", request).then((res) => {
    //     this.showDialog = false;
    //     this.$store.commit("clearApiError");
    //     this.action(si, obk, 'UASN', seqn);
    
 
    //   });
    // },

    getOutbound() {
      const load = this.getSelectedItems;
      console.log("Set Outbound");
      const time = moment().format('HH:mm:ss');
      const date = dateFormat.getLocalDateOnly(moment().toDate()) + 'T' + time;
      //api.post("/api/w/fsi/WebSaveOutbound", 
      newAPIPost("/api/w/fsi/WebSaveOutbound", 
      {
        mode: 'OOB',
        username: this.getUserProfile.username,
        outbound: load.map(it => {
          return {
            user: it.user,
            seqNo: it.seqNo,
            outboundDate: date,
          }
        })
      }
      ).then((res) => {
        this.showDialog = false;
        this.$store.commit("clearApiError");
        const loadRef = load.map(it => it.seqNo).toString();
        this.notifyMessage = `Loads {${loadRef}} has been sent to SAP.`;
        this.doSearch();
      });

    },

    getPhotoScanWt(item){
      this.isPictureModalShowing = true;
      this.photos = [];
      const selectedItem = item;
       console.log(selectedItem);
      if (selectedItem.scanWtLink != null)
      {
        let item = {
          title: "Scan Weight Ticket Image",
          photoUrl : selectedItem.scanWtLink
        };
        this.photos.push(item);
        
      }
       
    },

    getPhotos(){
      this.isPictureModalShowing = true;
      this.photos = [];
     
      const selectedItem = this.getSelectedItems[0];
       console.log(selectedItem);
      if (selectedItem.containerImage != null)
      {
        let item = {
          title: "CONTAINER IMAGE",
          photoUrl : selectedItem.containerImage
        };
        this.photos.push(item);
        
      }

      if (selectedItem.chassisImage != null)
      {
        let item = {
          title: "CHASSIS IMAGE",
          photoUrl : selectedItem.chassisImage
        };
        this.photos.push(item);
        
      }

      if (selectedItem.sealImage != null)
      {
        let item = {
          title: "SEAL IMAGE",
          photoUrl : selectedItem.sealImage
        };
        this.photos.push(item);
        
      }
       
    },

    getPhotoName(photo) {
        const photoName = decodeURI(photo.photoUrl.replace(/.*\//g, ""));
        return `${this.filePrefixForEachFile || ''}${photoName}`;
      },

    async toggleItemPhoto(item) {
        this.isPictureModalShowing = true;
        this.isLoading = true;
        //this.photos = (await api.post('/api/w/ccic/photo/get', { containerSeqNo: item.seqNo, outboundLoadingPic: true }));
        this.photos = (await newAPIPost('/api/w/ccic/photo/get', { containerSeqNo: item.seqNo, outboundLoadingPic: true }));

        if (item.bookingNo != null)
           this.photoZipFileName = `${item.seqNo}_${item.bookingNo}_${item.containerNo}.zip`;
        else
           this.photoZipFileName = `${item.seqNo}_${item.containerNo}.zip`;
        this.filePrefixForEachFile = `${item.containerNo}-`;
        console.log(this.photos)

    },

    doDownload() {
        this.downloading = true;
        const zipFileName = this.zipFileName || 'pictures.zip';
        const promises = _(this.testphotos)
          .map((photo) => {
            const a = document.createElement('a');
            a.href = photo.photoUrl;

            const req = {
              method: 'GET',
              mode: 'no-cors',
              cache: 'default',
            };

            const pathName = a.pathname;
            console.log(pathName);
            return fetch(pathName, req)
              .then(response => ({
                response,
                photo,
              }));
          });


        Promise.all(promises)
          .then((results) => {
            this.downloading = false;
            console.log(`aa`, results);
            const zip = new JSZip();
            _.chain(results)
              .groupBy(it => it.photo.containerNo)
              .each((values, k) => {
                console.log(values[0].photo.bookingNo)
                const target = (`${k}` !== `null`) ? zip.folder(k) : zip;
                _(values)
                  .each(({ response,photo }) => {
                    const res = response;
                    let filename = photo.containerNo + "-" + decodeURI(res.url.replace(/.*\//g, ""));
                    if (!filename.endsWith('png') || !filename.endsWith('jpg')) {
                      filename += '.png';
                    }
                    console.log(`filename=${filename}`);
                    const blob = res.blob();
                    target.file(filename, blob, { binary: true });
                  });
              });

            zip.generateAsync({ type: "blob" })
              .then((blob) => {
                const a = $("<a style='display: none;'/>");
                const url = window.URL.createObjectURL(blob);
                a.attr("href", url);
                a.attr("download", zipFileName);
                $("body")
                  .append(a);
                a[0].click();
                window.URL.revokeObjectURL(url);
                a.remove();
                this.isdownloadzip = false;
              });
          })
          .catch((e) => {
            console.error(e);
            this.downloading = false;
            this.isdownloadzip = false;
          });
    },


    async doPhotos(){
        this.isdownloadzip = true;
        this.testphotos = []
             const apis =  _(this.items).map((it) => 
       {
         console.log(it)
         //return new Promise(async (resolve) => await api.post('/api/w/ccic/photo/get', { containerSeqNo: it.seqNo })
         return new Promise(async (resolve) => await newAPIPost('/api/w/ccic/photo/get', { containerSeqNo: it.seqNo })
          .then((result) => {
                      console.log("result")
                       console.log(result)
                      result.forEach((it2) => {
                         it2.containerNo = it.containerNo
                         it2.bookingNo = it.bookingNo
                         this.testphotos.push(it2)
                      })
                      
                        resolve(it);
                      })
                      .catch((err) => {
                         console.log(err)
                        resolve(it);
                      }));
                      
                      
                      
                      });
         console.log(apis)
         Promise.all(apis)
                .then((temp) => {
                 
             
                 console.log("111");
                 console.log(temp);
                 this.doDownload();
                 
                 
                });
    },

    filterBar(){
      this.isFilterModalShowing = true;
    },

    toggleContainerCopy(element) {
      this.containerCopy = true;
      setTimeout(() => {
        this.containerCopy = false;
      }, 2000);
      var el = document.createElement("textarea");
      el.value = element;
      el.setAttribute("readonly", "");
      el.style = { position: "absolute", left: "-9999px" };
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    },

    doDownloadExcel(){
       const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'OutboundList.xls',
          1,
        );
        console.log("request heads: " + request.heads + ", " + request.heads.length);
          request.heads = _(request.heads).take(52);
          request.rows = _(this.items)
          .map(item => [
            item.loadStatus,
            item.receivingWindows,
            // item.driverLP,
            item.containerNo,
            item.chassisNo,
            (item.urgentContainer == true)? 'X' : '',
            this.getDisplay('CCR_CNTRTYPE', item.ctnrType),
            `${item.yard} - ${item.locationNumber}` ,
            //item.photoCount > 0 ? item.photoCount - 1 : 0,
            // item.stcSMSSend,

            // item.stcSMSDriver,
            item.scaleTicket,
            item.scanWt,
            item.scanWt == null ? item.scaleTicket : item.scanWt,
            item.scanWtLink == null ? "" : item.scanWtLink,
            item.twStation,
            dateFormat.date(item.twDate),
            dateFormat.time(item.twDate),
            dateFormat.time(item.twDateWeb),
            item.twYgNo,

            item.tareWeight == null ? "" : parseInt(item.tareWeight),
            item.grade, 
            item.specGrade,
            item.bales, 
            item.newSeal,
            item.gwStation,
            dateFormat.date(item.gwDate),
            dateFormat.time(item.gwDate),
            dateFormat.time(item.gwDateWeb),
            item.gwYgNo,

            item.vgmWeight == null ? "" : parseInt(item.vgmWeight),
            item.weight == null ? "" : parseInt(item.weight),
            item.bookingNo,
            item.ctnrCount,
            item.ctnrAssign,
            item.carrier2,
            item.ibd,
            item.deliveryOrder,
            item.ibs,
            dateFormat.date(item.assignDate),

            dateFormat.time(item.assignDate), 
            dateFormat.date(item.outboundDate),
            dateFormat.time(item.outboundDate),
            item.sapStatus, 
            item.carrier, 
            item.transloadingYard,     
            item.seqNo,
            dateFormat.date(item.unloadStartTimeStamp),
            dateFormat.time(item.unloadStartTimeStamp),
            dateFormat.date(item.unloadEndTimeStamp),

            dateFormat.time(item.unloadEndTimeStamp),
            item.uploadMobileUser,
            // item.status2
          ]);
        this.$store.dispatch('generateExcel', request)
          .then((res) => {
            window.open(res.url, 'blank');
          });
      },
      getyardloc(item) {
         var yard = "";
         var locNum = "";
         if (item.yard != null && item.yard != "") {
            yard = item.yard;
         }
         if (item.locationNumber != null && item.locationNumber != "") {
            locNum = item.locationNumber;
         }
         return yard + "-" + locNum;
      },
  },
};

  function UrlExists(url) {
     console.log("call UrlExists");
     fetch(url)
     .then(async response => {
        const data = await response.json();
        if (!response.ok) {
           console.log("data message: " + data.message + " & " + response.statusText);
           const error = (data && data.message) || response.statusText;
           //return Promise.reject(error);
           return false;
        }
        const totalVuePackages = data.total;
        console.log("totalVuePackages: " + totalVuePackages);
        return true;
     }
     )
     .catch (error => {
        //this.errorMessage = error;
        //console.error("There was an error!", error);
        console.log("There was an error!", error);
        return false;
     })
  }

</script>
